import { Pipe, PipeTransform } from '@angular/core';
import { flurTiefeText } from './flur-tiefe';

/**
 * „80" oder „10 cm über Flur" in den Uebersichten (flur-tiefe.ts). Bekommt die
 * Tiefe ab Flur, also bei einem Filz schon mit der Auflage: `tiefe(…) | flurTiefe`.
 */
@Pipe({ name: 'flurTiefe', standalone: true })
export class FlurTiefePipe implements PipeTransform {
	transform(angezeigt: number | null | undefined): string {
		return flurTiefeText(angezeigt);
	}
}
